// add app code here
import 'focus-visible/dist/focus-visible';

import './mapsight-glue';

import registerPWA from './modules/register-pwa';

// import './modules/photoswipe';

registerPWA();
